import { render, staticRenderFns } from "./TestsList.vue?vue&type=template&id=21ff2dec"
import script from "./TestsList.vue?vue&type=script&lang=js"
export * from "./TestsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports